export { usePauseVideoOnMobileBackground } from './usePauseVideoOnMobileBackground';
